import { apiRoot, db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import axios from "axios";
import {startLoading, stopLoading} from "../loader";

export async function importCompanies(userInfos) {
  startLoading();

  const res = await axios.get(apiRoot + "/api/v1/import-companies", {
    headers: {
      Authorization: userInfos.jwt,
    },
  });

  stopLoading();

  return res.data;
}

export async function createCompany(userInfos, company) {
  startLoading();

  let snap = await db.ref(`users/${userInfos.uid}/company`).push(company);
  snap = await db
    .ref(`users/${userInfos.uid}/company/${snap.key}`)
    .update({ id: snap.key });

  stopLoading();

  return snap;
}

export async function updateCompany(userInfos, company) {
  if (userInfos.company.id !== company.id) {
    startLoading();

    await db
      .ref(`users/${userInfos.uid}/company/${company.id}`)
      .update(company);

    stopLoading();
  }
}

export async function deleteCompany(userInfos, company_id) {
  if (!Array.isArray(company_id)) {
    company_id = [company_id];
  }

  startLoading();

  let pList = company_id.map(async (id) => {
    if (id) await db.ref(`users/${userInfos.uid}/company/${id}`).remove();
  });

  await Promise.all(pList);

  stopLoading();
}

export function useCompanies() {
  const { userInfos } = useContext(UserContext);
  const [companies, setCompanies] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/company")
      .once("value")
      .then((snapshot) => {
        let res = [];
        snapshot.forEach(function (childSnapshot) {
          if (childSnapshot.key === userInfos.company.id) {
            res.unshift({
              id: childSnapshot.key,
              ...childSnapshot.val(),
            });
          } else {
            res.push({
              id: childSnapshot.key,
              ...childSnapshot.val(),
            });
          }
        });

        setCompanies(res);
        setLoaded(true);
      });
  }, [userInfos.company.id, userInfos.uid]);

  return { companies, loaded };
}

export function useCompanyOptions(allOption = false) {
  const { userInfos } = useContext(UserContext);
  const [companyOptions, setCompanyOptions] = useState([]);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/company")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let res = [];
          snapshot.forEach(function (childSnapshot) {
            res.push({
              value: childSnapshot.key,
              label: childSnapshot.val().name,
              data: {
                ...childSnapshot.val(),
                id: childSnapshot.key,
              },
            });
          });

          if (allOption) {
            res.unshift({
              value: null,
              label: "Toutes les entreprises",
              data: null,
            });
          }

          setCompanyOptions(res);
        }
      });
  }, [allOption, userInfos.uid]);

  return companyOptions;
}
